import { Button, Table, Spinner, Row, Col } from "react-bootstrap";
import { useState } from 'react';
import { useTranslation } from "react-i18next";
import { useNavigate } from 'react-router-dom';
import AppTablePagination from "../../../components/AppTable/AppTablePagination";
import { ApiErrorResponse } from "../../../types/ApiErrorResponse";
import { SurveyImportPagination } from "../types";
import ModalGlobal from "../../../components/AppModal/ModalGlobal";
import { deleteSurveyImport, getProccessAI } from "../api/surveyImportAPI";



interface SurveyImportsTableProps {

    surveyImportData: SurveyImportPagination;
    totalPages: number;
    currentPage: number;
    pageSize: number;
    setMessage: (value: string) => void;
}

export default function SurveyImportTable({ surveyImportData, totalPages, currentPage, pageSize, setMessage }: SurveyImportsTableProps) {

    const { t } = useTranslation();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const navigate = useNavigate();
    const [surveyImportId, setSurveyImportId] = useState(0);
    const [totalSurveyImportResultToProcess, setTotalSurveyImportResultToProcess] = useState(0);
    const [surveyuploadDescription, setSurveyuploadDescription] = useState('');
    const [reasonDelete, setReasonDelete] = useState("");
    

    const [showModal, setShowModal] = useState(false);
    const handleOpen = () => setShowModal(true);
    const handleClose = () => setShowModal(false);
    const [showModalProcessAI, setShowModalProcessAI] = useState(false);
    const handleOpenProcessAI = () => setShowModalProcessAI(true);
    const handleCloseProcessAI = () => setShowModalProcessAI(false);

    const SURVEYLOAD_TABLE_HEADERS = {
        id: t("survey:load.headerTableSurveyLoad1"),
        uploadFile: t("survey:load.headerTableSurveyLoad2"),
        description: t("survey:load.headerTableSurveyLoad3"),
        status: t("survey:load.headerTableSurveyLoad4"),
        updateDate: t("survey:load.headerTableSurveyLoad5"),
        totalSurvey: t("survey:load.headerTableSurveyLoad6"),
        totalAIProcessed: t("survey:load.headerTableSurveyLoad7"),
        totalErrors: t("survey:load.headerTableSurveyLoad8"),
        actions: t("common:actions")
    };

    const formatDate = (date: Date) => {
        const d = new Date(date);
        const day = d.getDate().toString().padStart(2, '0');
        const month = (d.getMonth() + 1).toString().padStart(2, '0');
        const year = d.getFullYear();

        return `${day}/${month}/${year}`;
    };


    const getStateDescription = (state: number) => {
        if (state === 0) return t("survey:surveyImportDetail.surveyLoadStateIAPendient");
        if (state === 1) return t("survey:surveyImportDetail.surveyLoadStateIAProcessed");
        if (state === 2) return t("survey:surveyImportDetail.surveyLoadStateLoaded");
        if (state === 3) return t("survey:surveyImportDetail.surveyLoadStateCancel");
        if (state === 4) return t("survey:surveyImportDetail.surveyLoadStateError");
    }


    const handleProcessAI = async (numberOfRecords: number,  surveyImportIdSelect :number) => {
        setSurveyImportId(surveyImportIdSelect);
        setTotalSurveyImportResultToProcess(numberOfRecords);
        handleOpenProcessAI();
    }

    const sendProcessAI = async () => {
        try { 
            setLoading(true);
            
            await getProccessAI(surveyImportId);
            const updatedList = surveyImportData.items.map(item =>
                item.id === surveyImportId
                    ? { ...item, status: 0 }
                    : item);
            
            surveyImportData.items = updatedList;
            setLoading(false);
            setMessage(t("survey:load.surveyImportProcessAIMessage"));
            handleCloseProcessAI();
        } catch (error) {
            setLoading(false);
            const fetchError = error as ApiErrorResponse;
            setError(fetchError.message);
        } 
    }

    const handleDeleteSurveyLoad = async () => {
        try {
            setLoading(true);

            await deleteSurveyImport(surveyImportId, reasonDelete );
            const updateList = surveyImportData.items.filter(item => item.id !== surveyImportId);
            surveyImportData.items = updateList;
            setLoading(false);
            setReasonDelete("");
            handleClose();
            setMessage(t("survey:modal.messageDeleteSurveyLoadSuccessfully"));
        } catch (error) {
            setLoading(false);
            setError(t("survey:modal.messageDeleteSurveyLoadError"));


        }
    }

    const handleSurveyLoadDetail = (surveyImportId: number) => {
        navigate(`/survey-load/detail-survey-load/${surveyImportId}`);
    }

    const handleExportCsv = () => {
       
    }

    return (

        <div>
            {loading && (
                <div className="overlay-spinner">
                    <Spinner animation="border" variant="light" />
                </div>
            )}
            <ModalGlobal
                show={showModalProcessAI}
                onClose={handleCloseProcessAI}
                body={t("survey:load.modalTitleProcessAI", { count: totalSurveyImportResultToProcess })}
                onSave={() => {
                    sendProcessAI();
                }}
                saveText={t("common:buttons.buttonYes")}
                closeText={t("common:buttons.buttonNo")}
                isLoading={false}
            />
            <ModalGlobal
                show={showModal}
                onClose={handleClose}
                title={t("survey:modal.modalDeleteSurveyLoadTitle")}
                subtitle={t("survey:modal.modalDeleteSurveyLoadSubtitle", { description: surveyuploadDescription })}
                body={
                    <div>
                        <label>{t("survey:modal.modalDeleteSurveyLoadInput")}</label>
                        <input
                            type="text"
                            required
                            className="form-control"
                            value={reasonDelete}
                            onChange={(e) => setReasonDelete(e.target.value)} />
                        {error && <small className="text-danger">{error}</small>}
                    </div>}
                onSave={() => {
                    handleDeleteSurveyLoad();
                } }
                saveText={t("common:modalActionOK")}
                closeText={t("common:modalActionNOTOK")} isLoading={false}
            />
            <Row>
                <Col xs={12} md={12} >
                    {error && (
                        <div className="alert alert-danger">
                            {error}
                            <button
                                type="button"
                                className="btn-close btn-sm position-absolute top-0 end-0 m-2"
                                aria-label="Close"
                                onClick={() => setError('')}
                            ></button>
                        </div>
                    )}
                </Col>
            </Row>
            <Table responsive className="mt-3 ">
                <thead>
                    <tr>
                        {Object.values(SURVEYLOAD_TABLE_HEADERS).map((header, index) => (
                            <th key={Object.keys(SURVEYLOAD_TABLE_HEADERS)[index]} className="text-center" style={{ borderTop: "none", borderBottom: "1px solid black" }}>
                                {header}
                            </th>
                        ))}
                    </tr>
                </thead>

                {surveyImportData && surveyImportData.items.length > 0 ? (
                    <tbody>
                        {surveyImportData.items.map((data, index) => (
                            <tr key={index}>
                                <td className="text-center" style={{ verticalAlign: "middle" }}>
                                    <div>
                                        {data.id}
                                    </div>
                                </td>                           
                                <td className="text-start" style={{ verticalAlign: "middle" }}>
                                    <div>
                                        {data.fileName}
                                    </div>
                                </td>
                                <td className="text-start" style={{ verticalAlign: "middle" }}>
                                    <div>
                                        {data.description}
                                    </div>
                                </td>
                                <td className="text-center" style={{ verticalAlign: "middle" }}>
                                    <div>
                                        {getStateDescription(data.status)}
                                    </div>
                                </td>

                                <td className="text-center" style={{ verticalAlign: "middle" }}>
                                    <div>
                                        {formatDate(data.creationDate)}
                                    </div>
                                </td>

                                <td className="text-center" style={{ verticalAlign: "middle" }}>
                                    <div>
                                        {data.numberOfRecordsTotal}
                                    </div>
                                </td>
                                <td className="text-center" style={{ verticalAlign: "middle" }}>
                                    <div>
                                        {data.numberOfRecordsAIProcessed}
                                    </div>
                                </td>
                                <td className="text-center" style={{ verticalAlign: "middle" }}>
                                    <div>
                                        {data.numberOfRecordsError}
                                    </div>
                                </td>
                                <td className="text-center" style={{ verticalAlign: "middle" }}>
                                    <Button onClick={() => {
                                        setSurveyImportId(data.id);
                                        setSurveyuploadDescription(data.description)
                                        handleOpen(); 
                                    }} className="btn btn-sm btn-gris2" style={{ marginRight: 8, }}>
                                        <i className="bi bi-x" title={t("surveyAdmin:deleteSurveyLoad")}></i>
                                    </Button>
                                    <Button className="btn btn-sm btn-gris2" style={{ marginRight: 8, }} onClick={() => handleSurveyLoadDetail(data.id)}>
                                        <i className="bi bi-file-text" title={t("surveyAdmin:buttonShowDetailSurveyLoad")}></i>

                                    </Button>
                                    {data.status === 2 || data.status === 4 ? (
                                        <Button className="btn btn-sm btn-gris2" onClick={() => handleProcessAI(data.status === 4 ? data.numberOfRecordsError : data.numberOfRecordsTotal, data.id)}>
                                            < img src= "/paper-plane-top-thin-full.svg" title={ t("surveyAdmin:buttonProcessAISurveyLoad")} style={{ width: 16, height: 16 }} />
                                        </Button>
                                    ) : null}
                                   
                                    

                                    
                                </td>
                            </tr>
                        ))}
                    </tbody>
                ) : (

              
                <tbody>
                    <tr>
                      <td colSpan={Object.values(SURVEYLOAD_TABLE_HEADERS).length}>{t("survey:load.NonregistersSurveyLoads")}</td>
                    </tr>
                </tbody>
                )}

                <tfoot>
                    <AppTablePagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        pageSize={pageSize}
                        totalRecords={surveyImportData.totalRecords}
                        // colSpan={Object.values(SURVEYLOAD_TABLE_HEADERS).length}
                        showExportLink={true}
                        onExportCsv={handleExportCsv}
                        selectorType="surveyLoads"
                    />
                </tfoot>
            </Table>
            
        </div>
)}


